import React, { useEffect, useRef } from 'react'
import { makeStyles } from '@material-ui/styles'
import { animate, findClickedSceneObjects, init3DView } from './Grin3DViewerUtils'
import { DEFAULT_BACKGROUND_COLOR } from './Grin3DViewerConsts'

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    height: '100%',
    position: 'relative'
  }
}))

const Grin3DViewer = ({
  onMeshClicked = () => {},
  onSceneLoaded,
  onSceneRemoved = () => {},
  zCameraPosition = 50,
  cameraTopOffset,
  bgColor = DEFAULT_BACKGROUND_COLOR,
  zoom,
  zoomOnly = false,
  rotateAroundZAxis,
  cameraVector,
  customControls
}) => {
  const classes = useStyles()
  const containerRef = useRef()

  useEffect(() => {
    const { scene, camera, renderer, controls } = init3DView({
      containerElement: containerRef.current,
      zCameraPosition,
      hexBgColor: bgColor,
      cameraTopOffset,
      zoom,
      zoomOnly,
      customControls,
      rotateAroundZAxis,
      cameraVector
    })

    onSceneLoaded({ scene, camera, controls })

    const element = containerRef.current
    const onClick = event => {
      const intersectsObjects = findClickedSceneObjects({ event, camera, scene })
      onMeshClicked(intersectsObjects)
    }

    element.addEventListener('click', onClick)
    const newChild = element.appendChild(renderer.domElement)

    const animationFrameId = animate({ renderer, scene, camera, controls })

    return () => {
      cancelAnimationFrame(animationFrameId)
      onSceneRemoved({ scene, controls })
      element.removeEventListener('click', onClick)
      element.removeChild(newChild)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onSceneLoaded, rotateAroundZAxis])

  return <div ref={containerRef} className={classes.container} />
}

export default Grin3DViewer
